import LocationsWrapper  from './LocationsWrapper';

export default LocationsWrapper;
